import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 配乗アラート設定マスター
const enterpriseCrewAlertSettingsRepository = AiseaApiFactory.get(
  "enterpriseCrewAlertSettings"
);

/**
 * 配乗アラート設定マスターサービス
 */
const EnterpriseCrewAlertSettingsService = (() => {
  let _enterpriseCrewAlertSettings = null;

  const fetch = async () => {
    const res = await enterpriseCrewAlertSettingsRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseCrewAlertSettings = res.data;
    return _enterpriseCrewAlertSettings;
  };

  const clear = () => {
    _enterpriseCrewAlertSettings = null;
  };

  const findSettingBykind = kind => {
    if (!_enterpriseCrewAlertSettings) {
      return null;
    }

    return (
      _enterpriseCrewAlertSettings.alert_settings.find(
        setting => setting.kind === kind
      ) || null
    );
  };

  return {
    fetch,
    clear,
    findSettingBykind,
  };
})();

export default EnterpriseCrewAlertSettingsService;
